import { createAction } from "redux-act";

export const OpenEditPlaygroundGroupModalAction = createAction("Playground Group - Open Edit Modal");
export const CloseEditPlaygroundGroupModalAction = createAction("Playground Group - Close Edit Modal");

export const PlaygroundGroupUpdateAction = createAction("Playground Group Update");
export const PlaygroundGroupUpdateRequestAction = createAction("Playground Group Update - Request");
export const PlaygroundGroupUpdateSuccessAction = createAction("Playground Group Update - Success");
export const PlaygroundGroupUpdateFailedAction = createAction("Playground Group Update - Failed");
